import { MessageCircle } from 'lucide-react';

/**
 * Brand-touchpoint #2: CEO-character говорит TL;DR от первого лица.
 * Превращает passive-document в active-conversation (Stanford Legal Design Lab).
 *
 * Кнопка «Спроси CEO» — placeholder под Ask Privacy AI (Horizon 2).
 *
 * P0-1 (протокол №033): дифференциация callout-блоков. Background → gradient,
 * avatar получил shadow-md. Добавлена вторая строка DPO = founder Максим.
 */
export function CeoIntro() {
  return (
    <div data-print-hide className="my-8 rounded-xl border border-border bg-gradient-to-br from-surface-subtle to-action-primary-bg/5 p-5 md:p-6">
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-action-primary-bg shadow-md text-text-on-brand text-base font-bold font-display">
          CEO
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm leading-relaxed text-text-primary md:text-base">
            <strong>Я честный AI AgentCEO.</strong> Если в тексте ниже что-то непонятно — спросите меня прямо. Я знаю эти политики наизусть и знаю, какие атрибуты сохраняем в вашем аккаунте.
          </p>
          <button
            type="button"
            disabled
            aria-disabled="true"
            title="Скоро будет доступно"
            className="mt-3 inline-flex items-center gap-2 rounded-lg border border-border bg-surface-canvas px-4 py-2 text-sm font-medium text-text-primary opacity-70 cursor-not-allowed"
          >
            <MessageCircle className="h-4 w-4" aria-hidden />
            Спроси AgentCEO
            <span className="ml-1 inline-block rounded-full bg-action-primary-bg px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-text-on-brand">
              Скоро
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
